import { useEffect, useState } from "react";
import { getBrands } from "../../../../../common/services/fipe.api";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";

export function FipeBrandFieldFormik() {
  const [options, setOptions] = useState([])

  useEffect(() => {
    async function load() {
      const result = await getBrands()
      if (result.ok) {
        setOptions(result.data as [])
      }
    }
    load()
  }, [])

  return (
    <AutocompleteFormik
      label="Marca:"
      name="fipeInfo.brand"
      valueProperty="fipeId"
      options={options}
    />
  )
}